import { render } from "./ServiceCategoryCard.vue?vue&type=template&id=4c5a451f&scoped=true&ts=true"
import script from "./ServiceCategoryCard.vue?vue&type=script&lang=ts"
export * from "./ServiceCategoryCard.vue?vue&type=script&lang=ts"

import "./ServiceCategoryCard.vue?vue&type=style&index=0&id=4c5a451f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5a451f"]])

export default __exports__